/** @type {import('../schema').ProcessDefinition} */
const conciliacion = {
  id: "conciliacion",
  name: "Conciliación bancaria",
  category: "finanzas",
  outcome:
    "Sugerir coincidencias entre el extracto bancario y los pagos pendientes, para acelerar la verificación.",
  trigger: "El Administrador sube un extracto (CSV o imagen).",
  actors: ["Administrador", "Bot Habi", "Sistema"],
  status: "PARCIAL",
  description:
    "Carga de un extracto bancario, matching sugerido de solo lectura por Bot Habi contra pagos pendientes y aprobación en el flujo de Cobranza.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "habi", actor: "Bot Habi" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "admin",
      type: "start",
      label: "Carga del extracto",
      description: "Sube CSV o imagen del extracto bancario.",
      evidence: "src/screens/admin/ConciliacionBancaria.jsx:1-30",
    },
    {
      id: "s2",
      laneId: "habi",
      type: "task",
      label: "Matching sugerido",
      description:
        "Devuelve coincidencias contra payments pendientes del edificio. No escribe en Firestore.",
    },
    {
      id: "s3",
      laneId: "habi",
      type: "handoff",
      label: "Entrega de coincidencias al admin",
      description:
        "Las coincidencias sugeridas vuelven al Administrador para su revisión.",
    },
    {
      id: "s4",
      laneId: "admin",
      type: "decision",
      label: "¿La coincidencia es correcta (monto/fecha)?",
      description:
        "El Administrador valida la coincidencia sugerida.",
    },
    {
      id: "s5",
      laneId: "admin",
      type: "task",
      label: "Aprobación en Cobranza",
      description:
        "Usa el flujo de Cobranza/Pagos para aprobar el pago matcheado.",
    },
    {
      id: "s6",
      laneId: "admin",
      type: "task",
      label: "Conciliación manual",
      description: "Sin coincidencia válida, el admin concilia a mano.",
    },
    {
      id: "s7",
      laneId: "sys",
      type: "end",
      label: "Pago conciliado",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5", label: "Correcta" },
    { from: "s4", to: "s6", label: "Sin coincidencia" },
    { from: "s5", to: "s7" },
    { from: "s6", to: "s7" },
  ],
};
export default conciliacion;
